import { render, staticRenderFns } from "./gtr-notice.vue?vue&type=template&id=f8981d3a&scoped=true"
import script from "./gtr-notice.ts?vue&type=script&lang=ts&external"
export * from "./gtr-notice.ts?vue&type=script&lang=ts&external"
import style0 from "./gtr-notice.vue?vue&type=style&index=0&id=f8981d3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8981d3a",
  null
  
)

export default component.exports